import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[onlyNumber]',
  standalone: false
})
export class OnlyNumberDirective {
  private readonly regex: RegExp = new RegExp(/^\d*$/g);
  private readonly specialKeys: string[] = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    '-',
    'ArrowLeft',
    'ArrowRight',
    'Del',
    'Delete'
  ];

  constructor(private readonly el: ElementRef) {}
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.includes(event.key)) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [
      current.slice(0, position),
      event.key === 'Decimal' ? '.' : event.key,
      current.slice(position)
    ].join('');
    this.regex.lastIndex = 0;
    // eslint-disable-next-line
    if (next && !this.regex.exec(String(next))) {
      event.preventDefault();
    }
  }
}
